
let company = [
	{//【C企业主】服务介绍页-立即预约
		path: '/companyIndex',
		component: (r) => require.ensure([], () => r(require('@/pages/company/companyIndex')), 'companyIndex'),
		meta: {requireAuth: true, title: '童管家服务预约',}
	},
	{//【C企业主】企业信息录入
		path: '/companyInput',
		component: (r) => require.ensure([], () => r(require('@/pages/company/companyInput')), 'companyInput'),
		meta: {requireAuth: true, title: '童管家服务预约',}
	},
	{//【C企业主】合同预览
		path: '/contractPreviewPdf',
		component: (r) => require.ensure([], () => r(require('@/pages/company/contractPreviewPdf')), 'contractPreviewPdf'),
		meta: {requireAuth: true, title: '服务合同预览',}
	},
	{//【C企业主】企业主预约成功页面
		path: '/companySubmitSuccess',
		component: (r) => require.ensure([], () => r(require('@/pages/company/companySubmitSuccess')), 'companySubmitSuccess'),
		meta: {requireAuth: true, title: '预约成功',}
	},
	{//【C企业主】企业主订单信息
		path: '/companyOrder',
		component: (r) => require.ensure([], () => r(require('@/pages/company/companyOrder')), 'companyOrder'),
		meta: {requireAuth: true, title: '童管家服务订单',}
	},
	{//【C】添加预约人信息
		path: '/appointmentPeople',
		component: (r) => require.ensure([], () => r(require('@/pages/company/appointmentPeople')), 'appointmentPeople'),
		meta: {requireAuth: true, title: '添加预约人信息',}
	},
	{//【C】新增预约人成功页面
		path: '/addSuccess',
		component: (r) => require.ensure([], () => r(require('@/pages/company/addSuccess')), 'addSuccess'),
		meta: {requireAuth: true, title: '预约成功',}
	},
	{//【C】绑定服务页面
		path: '/bingCompanyServices',
		component: (r) => require.ensure([], () => r(require('@/pages/company/bingCompanyServices')), 'bingCompanyServices'),
		meta: {requireAuth: true, title: '童管家预约服务',}
	},
	{//【C】绑定成功
		path: '/bingSuccess',
		component: (r) => require.ensure([], () => r(require('@/pages/company/bingSuccess')), 'bingSuccess'),
		meta: {requireAuth: true, title: '童管家预约服务',}
	}
];

export default company;



// WEBPACK FOOTER //
// ./src/router/company.js